import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['textArea', 'focusButton'];

  connect() {
    let anchor = window.location.hash.substring(1);
    if (anchor === this.element.id) {
      this.focusButtonTarget.focus();
      this.darkenBgColor();
    } else {
      this.mainBgColor();
    }
  }

  darkenBgColor(e) {
    this.element.style.backgroundColor = '#e7e7e7';
    this.element.style.border = '1px solid #e7e7e7';
  }

  lightenBgColor(e) {
    this.element.style.backgroundColor = '#FFFFFF';
    this.element.style.border = '1px solid #d8d8d8';
  }

  mainBgColor(e) {
    this.element.style.backgroundColor = '#f6f7f8';
    this.element.style.border = '1px solid #f6f7f8';
  }

  addQuestionFocus() {
    this.textAreaTarget.focus();
  }
}
